import request from "@/api/request";

class Trangsaction{
    getTransaction(data){
        return request({
            url: "/api/transaction",
            method: "post",
            data: data
        });
    }
    getRecord(data){
        return request({
            url: "/api/transaction/record",
            method: "post",
            data: data
        });
    }
    getSummary(data){
        return request({
            url: "/api/transaction/summary",
            method: "post",
            data: data
        });
    }

    Cancel(data){
        return request({
            url: "/api/transaction/cancel",
            method: "post",
            data: data
        });
    }

    Refund(data){
        return request({
            url: "/api/transaction/refund",
            method: "post",
            data: data
        });
    }
}

export default new Trangsaction()